module.exports = __webpack_public_path__ + "static/img/iProX_logo.15d7b63f.png";